<template>
	<div>
		<div v-title data-title="HSNMS 管理系统"></div>
		<Head></Head>
		<div style="margin-top: 20px;"></div>
		<router-view />
	</div>
</template>
<script>
	import Head from './head.vue'
	export default {
		components: {
			Head
		},
		mounted() {
			this.$admin.getToken();
		}
	}
</script>
<style>
	
</style>



// WEBPACK FOOTER //
// src/components/views/admin/_layout/template_main.vue